import React from "react";

function Banner() {
  return (
    <div className="w-full h-[40vh] bg-slate-700 grid place-items-center">
      <h1 className="text-white text-6xl">SOLID ROCK CHRISTIAN ACADEMY</h1>
    </div>
  );
}

export default Banner;
